import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { atom, useSetAtom, useAtom } from 'jotai';
import { BlockListConfig, getBlockListConfig } from 'services/api/blockList';

const blockListConfigState = atom<BlockListConfig | null>(null);

export const useBlockListConfig = (enabled?: boolean) => {
  const [val, set] = useAtom(blockListConfigState);

  const { data, status } = useQuery({
    enabled: !val && enabled,
    queryFn: () => getBlockListConfig(),
  });

  useEffect(() => {
    if (status === 'success' && data) {
      set(data);
    }
  }, [status, data, set]);

  return val;
};

export const useSetBlockListConfig = () => {
  return useSetAtom(blockListConfigState);
};
